module.exports = __webpack_public_path__ + "static/img/advantage3.afaffc8.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/advantage3.webp
// module id = rfhI
// module chunks = 2